import { useState } from 'react';
import { Card } from '@/components/ui';
import { IconWallet } from '@/components/ui/icons';
import { AdminPage, AdminPageHeader } from '@/components/admin/shared';
import { WalletPanel } from '@/components/admin/WalletPanel';

/** Wallet — look up any wallet by scope + user id, view its balance + ledger,
 *  and post a manual adjustment. The same WalletPanel is embedded in the
 *  customer/driver drawers; this page is the direct-lookup entry. Covers the
 *  Filament CustomerWalletHistoryResource / DriverWalletHistoryResource +
 *  wallet adjust action. */
export function Wallet() {
  const [scope, setScope] = useState<'customer' | 'driver'>('customer');
  const [idInput, setIdInput] = useState('');
  const [active, setActive] = useState<{ scope: 'customer' | 'driver'; id: number } | null>(null);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const id = Number(idInput);
    if (Number.isInteger(id) && id > 0) setActive({ scope, id });
  };

  return (
    <AdminPage>
      <AdminPageHeader title="Wallet" subtitle="Look up a wallet ledger and post a manual adjustment." />

      <Card className="mb-4">
        <form onSubmit={submit} className="flex flex-wrap items-end gap-2">
          <div>
            <label className="block text-[11px] text-muted">Scope</label>
            <select
              value={scope}
              onChange={(e) => setScope(e.target.value as 'customer' | 'driver')}
              className="mt-1 input"
            >
              <option value="customer">customer (km-credit)</option>
              <option value="driver">driver (earnings)</option>
            </select>
          </div>
          <div>
            <label className="block text-[11px] text-muted">User ID</label>
            <input
              type="number"
              value={idInput}
              onChange={(e) => setIdInput(e.target.value)}
              placeholder="e.g. 42"
              className="mt-1 w-32 input"
            />
          </div>
          <button
            type="submit"
            className="btn-primary"
          >
            Open wallet
          </button>
        </form>
      </Card>

      {active ? (
        <div key={`${active.scope}:${active.id}`}>
          <div className="mb-2 text-xs text-muted">
            Showing <span className="text-slate-200">{active.scope}</span> wallet for user{' '}
            <span className="metric text-slate-200">#{active.id}</span>
          </div>
          <WalletPanel scope={active.scope} userId={active.id} />
        </div>
      ) : (
        <Card>
          <div className="flex items-center gap-3 py-6 text-sm text-muted">
            <IconWallet className="h-5 w-5" />
            Enter a scope + user id to load a wallet.
          </div>
        </Card>
      )}
    </AdminPage>
  );
}
